export const tpl = (template, variables) => {
  let string = template

  for (const value in variables) {
    string = string.replace(RegExp('{' + value + '}', 'g'), variables[value])
  }

  return string
}
